import { render, staticRenderFns } from "./Reflections.vue?vue&type=template&id=149413e6&scoped=true&"
import script from "./Reflections.vue?vue&type=script&lang=js&"
export * from "./Reflections.vue?vue&type=script&lang=js&"
import style0 from "./Reflections.vue?vue&type=style&index=0&id=149413e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149413e6",
  null
  
)

export default component.exports